'use strict';
const angular = require('angular');
var localisations = require('./menu.localisations');

/*@ngInject*/
export function commonService(Util, $mdToast, $mdBottomSheet, $window, $location, $http) {
  var safeCb = Util.safeCb;
  var pageTitleDefault = '';
  var pageTitle = pageTitleDefault;
  var sidenavOpen = false;
  var loading = false;
  var showNavbar = true;
  var alerting = false;
  var alertTitle = 'Alert.';
  var alertMessage = 'Some message goes here...';
  var alertButton = true;
  var alertClass = 'danger';
  var alertChoice = false;
  var alertTO = null;
  var alertChoiceTrueCallback = null;
  var alertChoiceFalseCallback = null;
  var backLink = null;
  var backLinkIcon = '';

  var locale = $window.localStorage.locale ? $window.localStorage.locale : navigator.languages ? navigator.languages[0].substring(0, 2) : 'en';

  var notificationLink = localisations[locale].notificationlink;
  var menuGuest = localisations[locale].menuguest;
  var menuUser = localisations[locale].menuuser;
  var menuAdmin = localisations[locale].menuadmin;
  var menuModerate = localisations[locale].menumoderate;
  var googleMapsApiKey = 'AIzaSyB7X7aeihX3lqAJOg9NhEW3XtF37OcEJQ4';
  return {

    getGoogleMapsApiKey() {
      return googleMapsApiKey;
    },

    getLocale() {
      return locale;
    },

    showNavbar(show) {
      showNavbar = show;
    },

    showBack() {
      return backLink !== null;
    },

    setBack(link, icon) {
      backLink = link;
      backLinkIcon = icon;
    },

    goBack() {
      console.log(backLink.indexOf('http'));      
      if(backLink.indexOf('http') > -1) {
        console.log('New Window');
        console.log(backLink);
        window.open(backLink, '_blank');
      } else {
        console.log('Location');
        $location.path(backLink);
      }
      backLink = null;
      backLinkIcon = null;
    },

    getBackLinkIcon() {
      return backLinkIcon;
    },

    isNavbarVisible() {
      return showNavbar;
    },

    setPageTitle(title) {
      if(title == '') {
        pageTitle = pageTitleDefault;
      } else {
        pageTitle = title;
      }
    },

    getPageTitle() {
      return pageTitle;
    },

    getNoteLink() {
        return notificationLink;
    },

    getMenuGuest() {
      return menuGuest;
    },

    getMenuUser() {
      return menuUser;
    },

    getMenuModerate() {
      return menuModerate;
    },

    getMenuAdmin() {
      return menuAdmin;
    },

    getSidenavOpen() {
      return sidenavOpen;
    },

    setSidenavOpen(newValue) {
      sidenavOpen = newValue;
    },

    setLoading(isLoading) {
      loading = isLoading;
    },

    isLoading() {
      return loading;
    },

    dismissAlert() {
      var that = this;
      alerting = false;
      alertTitle = 'Alert.';
      alertMessage = 'Nothing to see here...';
      alertClass = 'info';
      alertButton = true;
      alertChoice = false;
      clearTimeout(that.alertTO);
    },

    dismissAlertYes() {
      alerting = false;
      alertTitle = 'Alert.';
      alertMessage = 'Nothing to see here...';
      alertClass = 'info';
      alertButton = true;
      alertChoice = false;
      clearTimeout(alertTO);
      if(alertChoiceTrueCallback) {
        alertChoiceTrueCallback();
      }
      alertChoiceTrueCallback = null;
    },

    dismissAlertNo() {
      alerting = false;
      alertTitle = 'Alert.';
      alertMessage = 'Nothing to see here...';
      alertClass = 'info';
      alertButton = true;
      alertChoice = false;
      clearTimeout(alertTO);
      if(alertChoiceFalseCallback) {
        alertChoiceFalseCallback();
      }
      alertChoiceFalseCallback = null;
    },

    isAlerting() {
      return alerting;
    },

    getAlertTitle() {
      return alertTitle;
    },

    getAlertMessage() {
      return alertMessage;
    },

    getAlertClass() {
      return alertClass;
    },

    getAlertButton() {
      return alertButton;
    },

    getAlertChoice() {
      return alertChoice;
    },

    setAlert(title, aClass, message, useTO, showButton, showChoice, choiceTrueCallback, choiceFalseCallback) {
      var that = this;
      alertTitle = title;
      alertMessage = message;
      alertClass = aClass;
      alertButton = showButton;
      if(typeof showChoice !== 'undefined' && showChoice) {
        alertChoice = true;
      }
      if(useTO) {
        alertTO = setTimeout(function() {
          that.dismissAlert();
        }, 5000);
      }
      if(typeof choiceTrueCallback !== 'undefined' && choiceTrueCallback) {
        alertChoiceTrueCallback = choiceTrueCallback;
      }
      if(typeof choiceFalseCallback !== 'undefined' && choiceFalseCallback) {
        alertChoiceFalseCallback = choiceFalseCallback;
      }
      alerting = true;
    },

    unsetQuickNotification() {
      $mdToast.hide();
    },

    setQuickNotification(text, toastType) {
      if(typeof toastType == 'undefined') toastType = 'success';
      $mdToast.show($mdToast.simple({ position: 'top right', hideDelay: 3000, toastClass: toastType }).textContent(text));
    },

    sendUserAddress(data, callbackSuccess, callbackError) {
      var that = this;
      this.setLoading(true);
      var sas = '';
      for(var s = 0; s < data.socialapps.length; s++) {
        sas = sas + (', ' + data.socialapps[s]);
      }
      var promise = $http.post('/api/mails/sendAddress', {
        address: data.address,
        country: data.country,
        gender: data.gender,
        agerange: data.agerange,
        ethnicity: data.ethnicity,
        yeargroup: data.yeargroup,
        socialApps: sas,
        additionalhelp: data.additionalhelp
      });
      promise.then(response => {
        try {
          that.setQuickNotification('Address Sent', 'success');
          safeCb(callbackSuccess)(response.data);
        } catch(e) {
          console.log(e);
          that.setQuickNotification('Error sending address', 'danger');
          safeCb(callbackError)(err);
        }
      }).catch(err => {
        if(err.status != 401 && err.status != 404) {
          that.setAlert('Error', 'danger', `Error sending Address. Please try again. (Error ${err.status}: ${err.statusText})`, false, true);
        }
        if (err.status == 404) {
          that.setQuickNotification('Unable to send address', 'danger');
        }
        if(callbackError) {
          safeCb(callbackError)(err.data);
        } else if(callbackSuccess) {
          safeCb(callbackSuccess)(err.data);
        }
      });
    }
  };
}

export default angular.module('ffApp.common', [])
  .service('common', commonService)
  .name;



// WEBPACK FOOTER //
// ./client/components/common/common.service.js